import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeviceDetectorService } from './lib/device-detector.service';

@NgModule({
  imports: [
    CommonModule
  ]
})
export class DeviceDetectorModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: DeviceDetectorModule,
      providers: [DeviceDetectorService]
    };
  }
}

export { DeviceDetectorService, DeviceInfo } from './lib/device-detector.service';
export { ReTree } from './lib/retree';
export * from './lib/device-detector.constants';

